<template>
  <div>
    <a
      v-if="modalVariation==1"
      class="text-primary"
    >
      {{ __("lang.kwl.info.button.no_measure_required") }}
    </a>
    <a href="#"
       v-else
       class="text-primary"
       v-b-modal.variationModal
    >
      {{ __("lang.kwl.info.button.additional_measure_recommended") }}
    </a>

    <b-modal id="variationModal" :title="__('lang.kwl.info.text.additional_measure_recommended')" size="lg" hide-footer>
      <div v-if="modalVariation==2 || modalVariation==3" class="modal-lg">
        <p>{{ __("lang.kwl.info.text.additional_measure_recommended_p1") }}</p>

        <ul class="list-unstyled square square-small">
          <li>{{ __("lang.kwl.info.text.additional_measure_recommended_p2") }}</li>
          <li>{{ __("lang.kwl.info.text.additional_measure_recommended_p3") }}</li>
          <li>{{ __("lang.kwl.info.text.additional_measure_recommended_p4") }}</li>
          <li>{{ __("lang.kwl.info.text.additional_measure_recommended_p5") }}</li>
          <li>{{ __("lang.kwl.info.text.additional_measure_recommended_p6") }}</li>
        </ul>
      </div>
      <!--      <div v-else-if="modalVariation==2">-->
      <!--        <p>text 2</p>-->
      <!--      </div>-->
      <!--      <div v-else>-->
      <!--        <p>text 3</p>-->
      <!--      </div>-->

    </b-modal>

  </div>
</template>

<script>
import Unit from '@models/building/Unit'
import log from '@services/logger/index'
import {setLabels} from '@services/helpers/langHandler'

export default {
  props: ['modalVariation'],
  data() {
    return {
      sortBy: 'name',
      sortDesc: false,
    }
  },
  methods: {
    setLabels: setLabels,

    resetAirvolumeCalculations() {
      this.rooms.forEach((room) => (room.airvolume.resetFZu = true))
      Room.insertOrUpdate({data: this.rooms})
      this.unit.airvolume.manually = 0
      this.airvolumeCalculations()
    },
  },
  computed: {
    unit() {
      return Unit.query().where('id', this.unitId).with(['airvolume', 'rooms.airvolume']).first()
    },
  },
  created() {
    //this.OperationmodeOptions
    //this.OperationmodeAirvolumeOptions
  },
}
</script>
